import util from '../util'

let controller = 'Doacao'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']), {
  AceitarDoacao: function (dto) {
    return util.Axios.Post(controller + '/Aceitar', dto)
  },
  ReprovarDoacao: function (dto) {
    return util.Axios.Post(controller + '/Reprovar', dto)
  }
})
